import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { FertiliserOrderplan, FertilisersState } from '../../models';
import { FertilisersActionTypes, FertilisersActions } from '../actions/fertilisers-actions';

export const adapter: EntityAdapter<FertiliserOrderplan> = createEntityAdapter<FertiliserOrderplan>();
export const initialFertilisersState: FertilisersState = adapter.getInitialState({});

// add switch cased to the reducer for every action
// or combine reducers from the reducers subfolder right here
export const fertilisersReducer = (state = initialFertilisersState, action: FertilisersActions): FertilisersState => {
  switch (action.type) {
  case FertilisersActionTypes.GetFertiliserOrderplanSuccess: {
    return {
      ...state,
      fertiliserOrderplan: action.result.orderableProducts,
      nonOrderableFertilisers: action.result.nonOrderableProducts,
      proprietaryFertilisers: action.result.proprietaryFertilizers,
    };
  }

  case FertilisersActionTypes.GetArticlesByCropAidsSuccess: {
    return {
      ...state,
      articlesByCropAids: action.result.cropAids,
    };
  }

  case FertilisersActionTypes.SetCustomerFertilizerStock: {
    return {
      ...state,
      customerFertilizerStock: action.customerFertilizerStock,
    };
  }

  default:
    return state;
  }
};
